export default __webpack_public_path__ + "static/media/Filing_system.34887b4f.svg";